import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import {MenuItem, LazyLoadEvent,} from 'primeng/api';
import {LookupCategoryService} from '../../../services';
import { IGlobalSearchParam, ISearchGlobalFilter } from '../../../../shared/models/Global-Search.model';
import {DialogService} from 'primeng/dynamicdialog';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import { Message } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { SharedService } from '../../../../shared/services/shared.service';
import { SelectItem, FilterService, FilterMatchMode } from "primeng/api";
import { Table } from 'primeng/table';
import { LookupCategory } from '../../../../admin/models';
import { ExcelService } from '../../../../shared/services/excel.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as fs from 'file-saver';

@Component({
  selector: 'app-lookup-category-search',
  templateUrl: './lookup-category-search.component.html',
  styleUrls: ['./lookup-category-search.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})

export class LookupCategorySearchComponent implements OnInit {


  
   //currentUser;
   showTopFilters: boolean;
   showFilters:boolean;
   showSorting:boolean;
   matchModeOptions: SelectItem[];
   matchModeOptionsForDate: SelectItem[];
   matchModeOptionsForNumeric: SelectItem[];
   showAddRuleButton:boolean = false;
   oldSortField:string = 'createdOn';
   oldSortOrder:string = 'desc';
   sortField:string = 'createdOn';
   sortOrder:string = 'desc';
   appliedFilters:{field:string,matchMode:string,value:string}[]=[];
   pageNo: number =1;
   pageSize: number =10;
   oldPageNo: number =1;
   oldPageSize: number =10;
   totalRecords: number;
   loadEvent: LazyLoadEvent;
   filters;
   filterCondition: { fieldName: string; type: string; }[] =[];
   startSearch: boolean = false;
   lookupCategoryList;
   gridSpinner = 'gridSpinner1';
   isSearchLoading: boolean = false;
   loading: boolean = false;
   lookupCategorySearchParam:IGlobalSearchParam;
   items: MenuItem[];
   lookupCategorySearchSpinner = 'lookupCategorySearchSpinner';
   ref: DynamicDialogRef;
   msgs: Message[] = [];
   dialogPosition = 'topright';
   isLookupCategoryAdd : boolean = false;
   isLookupCategoryEdit : boolean = false;
   buttonLabel: string = "";
   title: string = "";
   lookupCategoryForm:FormGroup;
   selectedGridMenuItem:any = null;
   showToggle:boolean;
   isshowpaginator:boolean=true;
   statusValues:any;
   selectedStatusId:any="All";
   selectedStatus:any;
   allColumns = [
    { value: 'action', header: 'Action' },
    { value: 'categoryName', header: 'Lookup Category Name' },
    { value: 'description', header: 'Description' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]

  selectedColumns = [
    { value: 'action', header: 'Action' },
    { value: 'categoryName', header: 'Lookup Category Name' },
    { value: 'description', header: 'Description' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]
  @ViewChild('dt2', { static: true }) table: any;

   constructor(
     public datepipe: DatePipe,
    // private storage: LocalStorageService,
     private spinner: NgxSpinnerService,
     private lookupCategoryService:LookupCategoryService,
     private dialogService: DialogService,
     private confirmationService: ConfirmationService,
     private messageService: MessageService,
     private primengConfig: PrimeNGConfig,
     private _fb: FormBuilder,
     private excelService:ExcelService,
     private _router: Router,
     public sharedService: SharedService

   ) 
   {
     this.showFilters = false;
     this.showSorting = false;
     this.spinner.show();
     setTimeout(() => {
         this.spinner.hide();
     }, 1000);
     /*this.items = [
     
      {
       label:'Edit',
       icon:'pi pi-fw pi-pencil',
       command: e => this.editLookupCategoryDetails(this.selectedGridMenuItem.categoryId)
      },
      {
       label:'Delete',
       icon:'pi pi-fw pi-trash',
       command: e => this.deleteConfirm(this.selectedGridMenuItem.categoryId)
      }
   ];*/
     //this.currentUser = this.storage.retrieve('currentuser');
     
    
   }
 
   ngOnInit(): void {
    this.checkViewPermission();
    this.items = [];
    this.checkEditDeletePermission();

     const customFilterName = "custom-equals";
     const notEquals = "not-equals";
     const dateAfter = "date-after";
     const dateBefore = "date-before";
     
     this.matchModeOptions = [
       { label: "Custom Equals", value: customFilterName },
       { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
       { label: "Contains", value: FilterMatchMode.CONTAINS }
     ];
 
     this.matchModeOptionsForDate = [
      { label: "Equals", value: customFilterName },
      { label: "Not Equals", value: notEquals },
      { label: "Greater Than", value: dateAfter },
      { label: "Less Than", value: dateBefore },
     ];
 
     this.matchModeOptionsForNumeric = [
       { label: "Custom Equals", value: customFilterName },
       { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
       { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
     ];
 
     this.filterCondition=[
       {fieldName:"categoryName",type:"basic"},
       {fieldName:"description",type:"basic"},
       {fieldName:"isActive",type:"basic"},
       {fieldName:"createdBy",type:"basic"},
       {fieldName:"createdOn",type:"date"},
     ];
     this.appliedFilters.push({ field:"globalfilter", matchMode:"equals", value:"0" }) 
     this.getAllLookupCategoryList();
     this.statusValues=['All','Active',"Inactive"];
     this.InitialSetup();
   }
   checkViewPermission()
   {
     var result = this.sharedService.checkPermission("Admin_View");
     if(!result)
     this._router.navigateByUrl('/login');
   }
   InitialSetup(){
     this.lookupCategoryForm = this._fb.group({
       categoryId: new FormControl(0,[Validators.required]),
       categoryName: new FormControl("",[Validators.required]),
       description: new FormControl("",[Validators.required]),
       isActive: new FormControl(false,[Validators.required]),
       createdBy: new FormControl(""),
       createdOn: new FormControl(""),
       modifiedBy: new FormControl(""),
       modifiedOn: new FormControl("")
     })
   }
   
   getAllLookupCategoryList()
   {
     this.lookupCategorySearchParam = 
        {
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          sortField:this.sortField,
          appliedFilters:this.appliedFilters,
          sortOrder:this.sortOrder
        };
        this.spinner.show(this.lookupCategorySearchSpinner);
     this.lookupCategoryService.getAllLookupCategories(this.lookupCategorySearchParam).subscribe((data: any) => {
       this.appliedFilters = [];
       this.lookupCategoryList =data;
       this.isshowpaginator=this.lookupCategoryList.length>0?true:false;
       this.totalRecords = data[0].totalCount;
       this.spinner.hide(this.lookupCategorySearchSpinner);
      });
   }
 
 
   loadLookupCategoryList(event:LazyLoadEvent)
   { 
     this.loadEvent=event;
     if(event.first==0)
     {
       this.pageNo = 1;
     }
     else {
       this.pageNo=(event.first/event.rows)+1;
     }
     this.pageSize=event.rows;
     
     this.pageSize=event.rows;
     
     if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
     {
      this.applyFilter();
      this.getAllLookupCategoryList();
     }
     this.oldPageNo = this.pageNo;
     this.oldPageSize = this.pageSize;
     this.filters=event.filters;
     if(this.filters["createdOn"]!= undefined)
     {
     if(this.filters["createdOn"][0].matchMode == "date-after")
     {
        this.showAddRuleButton = true;
     }
     else{
       this.showAddRuleButton = false;
     }
     }
     this.sortField=event.sortField;
     if(event.sortField === undefined|| event.sortField === null)
     {
       this.sortField='createdOn';
     }
     if(event.sortOrder === 1)
     {
     this.sortOrder='desc';
     }
     if(event.sortOrder === -1)
     {
     this.sortOrder='asc';
     }
     /*if(this.sortField !== 'createdOn')
     {
       this.getAllLookupCategoryList()
     }*/
 
     if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
     {
       this.applyFilter();
       this.getAllLookupCategoryList()
     }
     this.oldSortField = this.sortField;
     this.oldSortOrder = this.sortOrder;
   }
 
 
   search()
   {
     for(let i=0;i<this.filterCondition.length;i++)
     {
       if(this.filterCondition[i].type == "checkbox")
       {
         if(this.filters[this.filterCondition[i].fieldName].value == true)
         {
           this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:"true"}) 
         }
         else if (this.filters[this.filterCondition[i].fieldName].value == false){
           this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:"false"}) 
         }
       }
       else {
         this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:this.filters[this.filterCondition[i].fieldName].value}) 
       }
       if(i==this.filterCondition.length-1 )
       {
         this.startSearch = true; 
       } 
     }
     if(this.startSearch == true)
     {
       this.lookupCategorySearchParam = 
        {
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          sortField:this.sortField,
          appliedFilters:this.appliedFilters,
          sortOrder:this.sortOrder
        };
        this.spinner.show(this.lookupCategorySearchSpinner);
       this.lookupCategoryService.getAllLookupCategories(this.lookupCategorySearchParam).subscribe((data: any) => {
         this.appliedFilters = [];
         this.lookupCategoryList =data;
         this.totalRecords = data[0].totalCount;
         this.spinner.hide(this.lookupCategorySearchSpinner);
        });
     }
   }
 
 
 
 
   showLookupCategoryDetails(paramId: number)
   {
  //    this.ref = this.dialogService.open(LookupCategoryViewModalComponent, {
  //      header: 'LookupCategory Details',
  //      width: '50%',
  //      contentStyle: {"max-height": "500px", "overflow": "auto"},
  //      baseZIndex: 10000,
  //      data: {id: paramId}
  //  });
   }
 
 
 
 
   deleteConfirm(paramId:number) {
     this.dialogPosition = 'topright';
     this.confirmationService.confirm({
       message: 'Do you want to delete this lookupCategory?',
       header: 'Delete Confirmation',
       icon: 'pi pi-info-circle',
       accept: () => {
         this.lookupCategoryService.deleteLookupCategory(paramId).subscribe((data: any) => {
           this.getAllLookupCategoryList();
           this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have deleted the record'});
          });
       },
       reject: (type) => {
         switch(type) {
             case ConfirmEventType.REJECT:
                 this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
             break;
             case ConfirmEventType.CANCEL:
                 this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
             break;
         }
       },
       key: "positionDialog"
     });
   }
 
   addLookupCategoryDetails(){
     this.InitialSetup();
     this.isLookupCategoryAdd = true;
     this.isLookupCategoryEdit = false;
     this.title = "LookupCategory Add";
     this.buttonLabel = "Save";
   }
 
   editLookupCategoryDetails(paramId: number)
   { 
     this.InitialSetup();
     this.isLookupCategoryEdit = true;
     this.isLookupCategoryAdd = false;
     this.title = "LookupCategory Edit";
     this.buttonLabel = "Update";
     this.lookupCategoryService.getLookupCategoryById(paramId).subscribe((data:LookupCategory) =>{
       this.lookupCategoryForm.patchValue(data[0]);
     },error => {
       console.log(error)
     })
   }
 
   cancel(){
     this.isLookupCategoryAdd = false;
     this.isLookupCategoryEdit = false;
   }
 
   save({value}: {value: LookupCategory}){
     if(value.categoryId === 0){
       value.createdBy = 1;
       value.createdOn = new Date();
       this.lookupCategoryService.postLookupCategory(value).subscribe(data => {
         this.getAllLookupCategoryList();
         this.isLookupCategoryAdd = false;
       }, error => {
         console.log(error)
       })
     }else{
       this.lookupCategoryService.updateLookupCategory(value.categoryId, value).subscribe(data => {
         this.getAllLookupCategoryList();
         this.isLookupCategoryEdit = false;
       }, error => {
         console.log(error);
       })
     }
   }
 
   clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
     table.clear();
     this.selectedStatus="";
     this.selectedStatusId=undefined;
     this.appliedFilters = [];
    //  this.applyFilter();
    this.getAllLookupCategoryList();
   }
   
   bindShowFilter() {
     this.showFilters = (this.showFilters ? false : true)
   }
 
   bindShowSorting() {
     this.showSorting = (this.showSorting ? false : true)
   }
 
   bindShowTopFilter() {
     this.showTopFilters = (this.showTopFilters ? false : true)
   }
 
   applyFilterNew(table: Table){
     this.filters=table.filters;
     this.applyFilter();
   }
 
   applyFilter()
   {
     if (Object.keys(this.filters).length > 1) {
       this.appliedFilters = [];
       for (let i = 0; i < this.filterCondition.length; i++) {
         if (this.filterCondition[i].type == "checkbox") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: "true"
               })
             }
             else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: "false"
               })
             }
           }
         }
         else if (this.filterCondition[i].type == "basic") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: this.filters[this.filterCondition[i].fieldName][0].value
               })
             }
           }
         }
         else if (this.filterCondition[i].type == "date") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
               if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
                 this.appliedFilters.push({
                   field: this.filterCondition[i].fieldName,
                   matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
                   value: this.datepipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy")
                 })
             }
           }
         }
         else if (this.filterCondition[i].type == "numeric") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: this.filters[this.filterCondition[i].fieldName][0].value
               })
           }
         }
     }
     }
 
     if(this.startSearch == true || this.startSearch == false)
     {
       this.lookupCategorySearchParam = 
        {
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          sortField:this.sortField,
          appliedFilters:this.appliedFilters,
          //searchGlobalFilter: this.searchGlobalFilter,
          sortOrder:this.sortOrder
        };
       this.spinner.show(this.lookupCategorySearchSpinner);
       this.lookupCategoryService.getAllLookupCategories(this.lookupCategorySearchParam).subscribe((data: any) => {
       this.lookupCategoryList =data;
       this.isshowpaginator=this.lookupCategoryList.length>0?true:false;
       this.totalRecords = data[0].totalCount;
       this.spinner.hide(this.lookupCategorySearchSpinner);
       });
     }
   }

   exportExcel() {
    let header = ['Lookup Category Name', 'Description', 'Is Active', 'Created By', 'Created On'];
    let jsonKey = ['categoryName', 'description', 'isActive', 'createdByUser', 'createdOn'];
    let data = this.lookupCategoryList;
    var arrFinalData = [];
    var columnsKeyNames = [];
    for (var i = 0; i < data.length; i++) {
      var singleRow_temp = data[i];
      columnsKeyNames = Object.keys(singleRow_temp);
      var column0_temp = "";
      var column1_temp = "";
      var column2_temp = "";
      var column3_temp = "";
      var column4_temp = "";
      for (var j = 0; j < columnsKeyNames.length; j++) {
        if (columnsKeyNames[j] == jsonKey[0]) {
          column0_temp = singleRow_temp[columnsKeyNames[j]];
        }
        if (columnsKeyNames[j] == jsonKey[1]) {
          column1_temp = singleRow_temp[columnsKeyNames[j]];
        }
        if (columnsKeyNames[j] == jsonKey[2]) {
          if(singleRow_temp[columnsKeyNames[j]] == true){
            column2_temp = 'ACTIVE';
          }
          if(singleRow_temp[columnsKeyNames[j]] == false){
            column2_temp = 'INACTIVE';
          }
        }
        if (columnsKeyNames[j] == jsonKey[3]) {
          column3_temp = singleRow_temp[columnsKeyNames[j]].firstName;
        }
        if (columnsKeyNames[j] == jsonKey[4]) {
          column4_temp = this.datepipe.transform(singleRow_temp[columnsKeyNames[j]],'MM/dd/yyyy');
        }
      }
      arrFinalData.push([column0_temp,column1_temp,column2_temp,column3_temp,column4_temp])
    }
    this.excelService.exportExcel(header,arrFinalData,'lookup-category-search')
  }

  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  showAndHideColumn(event){
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      console.log("length is "+tempColumn.length);
      return true;
    }
    return false;
  }

  checkEditDeletePermission() {
    var isAdminAdd = this.sharedService.checkPermission("Admin_Add");
    var isAdminDelete = this.sharedService.checkPermission("Admin_Delete");
    if (isAdminAdd) {
      var editItem = {
        label:'Edit',
        icon:'pi pi-fw pi-pencil',
        command: e => this.editLookupCategoryDetails(this.selectedGridMenuItem.categoryId)
      }
      this.items.push(editItem)
    }
    if(isAdminDelete){
      var deleteItem =  {
        label:'Delete',
        icon:'pi pi-fw pi-trash',
        command: e => this.deleteConfirm(this.selectedGridMenuItem.categoryId)
       }
       this.items.push(deleteItem);
    }
  }

 getStatusOnChange(event)
 {
  this.selectedStatusId = event.value;
  this.selectedStatus=event.value;
 }

 clearStatus()
 {
  this.selectedStatus ="";
  this.selectedStatusId = undefined;
 }
 
 exportLookupCategory() {
  this.applyFilter();
  this.lookupCategorySearchParam = 
  {
    pageNo:this.pageNo,
    pageSize:this.pageSize,
    sortField:this.sortField,
    appliedFilters:this.appliedFilters,
    sortOrder:this.sortOrder
  };
  this.lookupCategoryService.ExportLookupCategory(this.lookupCategorySearchParam).subscribe(res => {
  var blob = new Blob([res.body], { type: res.body.type });
  const file = new File([blob],"LookupCategory.xlsx", { type: res.body.type });
  fs.saveAs(file);
  });
}

}
